import { render, staticRenderFns } from "./CpttEditMain.vue?vue&type=template&id=9aa98b7c&scoped=true&"
import script from "./CpttEditMain.vue?vue&type=script&lang=js&"
export * from "./CpttEditMain.vue?vue&type=script&lang=js&"
import style0 from "./CpttEditMain.vue?vue&type=style&index=0&id=9aa98b7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa98b7c",
  null
  
)

export default component.exports